/* eslint-disable */
'use strict';

const KlaviyoNewsletter = {
    init: function() {
        this.bindEvents();
    },


    bindEvents: function() {
        document.querySelectorAll('.js-newsletter-submit').forEach(el => {
            el.addEventListener('click', function(e) {
                e.preventDefault();
    
                // Selectors
                const formSelector =  e.target.closest('form');
                const emailInput = formSelector.querySelector('input[name="contact[email]"]');
                const isEmail = KlaviyoNewsletter.isEmail(emailInput.value);
                const messageSelector = formSelector.querySelector('.js-feedback-message');
    
                // If email is given send the data to klaviyo, otherwise show a message
                if (isEmail) {
                    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
                        headers: {
                            accept: 'application/json, text/plain, */*',
                            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
                        },
                        body: new URLSearchParams({g: 'L5HTuL', email: emailInput.value}),
                        method: 'POST',
                    }).then(response => {
                        return response.json();
                    }).then(data => {
                        if (data.data.is_subscribed) {
                            KlaviyoNewsletter.dispatchMessage(messageSelector, 'You have already subscribed.');
                            messageSelector.classList.remove('success');
                            messageSelector.classList.add('error');
                        }

                        if (data.data.is_subscribed == false && data.success) {
                            KlaviyoNewsletter.dispatchMessage(messageSelector, 'You have subscribed successfuly.');
                            messageSelector.classList.remove('error');
                            messageSelector.classList.add('success');
                        }
                    });
    
                } else {
                    messageSelector.innerHTML = 'Please enter a valid email address.'
                    messageSelector.classList.remove('success');
                    messageSelector.classList.add('error');
                }
                
            });
        })
    },


    dispatchMessage: function(selector, message) {
        selector.innerHTML = message;
    },


    /**
     * Check if string is email
     * @param {string} email 
     * @returns 
     */
    isEmail: function (email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    
};

export default KlaviyoNewsletter;